export class Cargo {
    ncargoId: number;
    ccargoDsc: string;
    ccargoFlgactivo: boolean;
  }

